/**
 * Sold Card Carousel Handlers for Native Interactive Site Map (ISM)
 *
 * Owns DOM lookup and geometry calculations for the bottom sheet's one-at-a-time Sold carousel.
 * This module has no Redux, Subject-emitting, or plugin lifecycle responsibilities.
 *
 * @module nativeInteractiveSiteMap/handlers/soldCardCarouselHandlers
 */

// Dedicated data-attribute hooks authored by services/listViewContentService.js's
// renderSoldHomeCards — not styling classes or the generic data-lot-id.
const SCROLL_CONTAINER_SELECTOR = '[data-sold-card-carousel]';
const CARD_SELECTOR = '[data-sold-card-group]';

function createSoldCardCarouselHandlers() {
  function findScrollContainer(panel) {
    return panel.querySelector(SCROLL_CONTAINER_SELECTOR);
  }

  // Picks the card whose horizontal center is closest to the scroll container's — matches where
  // `scroll-snap-align: center` settles the "active" card once a swipe finishes.
  function findActiveLotId(scrollContainer) {
    const containerRect = scrollContainer.getBoundingClientRect();
    const containerCenter = containerRect.left + containerRect.width / 2;

    let closestLotId = null;
    let closestDistance = Infinity;

    scrollContainer.querySelectorAll(CARD_SELECTOR).forEach((card) => {
      const cardRect = card.getBoundingClientRect();
      const distance = Math.abs((cardRect.left + cardRect.width / 2) - containerCenter);

      if (distance < closestDistance) {
        closestDistance = distance;
        closestLotId = card.dataset.lotId;
      }
    });

    return closestLotId;
  }

  return { findScrollContainer, findActiveLotId };
}

export default createSoldCardCarouselHandlers;
